import axios from 'axios'

import { Nominal } from '@espoon-voltti/nuora-app-common/types/common'

export type Token = Nominal<'token'>
export const tokenOf = (x: string): Token => ({ type: 'token', value: x })

export interface AuthApi {
  getToken(): Promise<Token>
}

class AuthApiClient implements AuthApi {
  public getToken(): Promise<Token> {
    return axios.get('/auth/token').then(({ data }) => tokenOf(data))
  }
}

export const authApi: AuthApi = new AuthApiClient()
